module.exports = __webpack_public_path__ + "static/media/rotor.b8e2b25e.png";